export function checkObjectKey(object,key)
  {
    let check = false

    if(object.hasOwnProperty(key))
    {
      if (object[key]!==null)
       {
          check = true
       }
    }

    return  check
  }